import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import queryString from "query-string";
import lottieAuthenticate from "assets/authenticate.json";
import lottieDenied from "assets/denied.json";

import { Redirect } from "react-router";

export default function SingleSignOne({ location }) {
  const { jwt } = queryString.parse(location.search);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function authenticate() {
      if (!jwt) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setLoaded(true)
        return;
      };

      await localStorage.setItem("auth_token", jwt);

      await new Promise((resolve) => setTimeout(resolve, 4000));

      setLoaded(true);
    }

    authenticate();
  }, [jwt]);

  if (loaded) {
    return <Redirect to="/" />;
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!jwt ? (
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData: lottieDenied,
          }}
          height={400}
          width={400}
        />
      ) : (
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData: lottieAuthenticate,
          }}
          height={400}
          width={400}
        />
      )}
    </div>
  );
}
